import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";
import { styled, Typography } from "@mui/material";
import { useTheme } from "@mui/system";
import TotalPriceIcon from "assets/icons/TotalPriceIcon";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import TableSelectInvoice from "components/Input/TableSelectInvoice";
import { PriceComponent } from "components/Shared/Dashboard/styled";
import { ExportContainer, Item } from "components/Table/ExportBotton";
import { indexData } from "forms";
import { formatPrice } from "helpers/dataFormat";
import useDateState from "helpers/useDateState";
import { useSelector } from "react-redux";
import { StyledListItemIcon, StyledListItemText } from "../components";
import { store } from "store/store";
import axios from "../../../axios/axios";
import { DateToString } from "../DateFilter";
import fileDownload from "js-file-download";
import { errorDispatcher } from "helpers";
import { appSetLoading } from "store/actions/appAction";

const MainContainer = styled("div")(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  marginTop: "20px",
  display: "flex",
}));
const LowerSectionContainer = styled("div")(({ theme }) => ({
  backgroundColor: "white",
  display: "flex",
  flexWrap: "wrap",
  gap: "24px",
  padding: "10px",
  borderRadius: theme.shape.borderRadius,
  width: "100%",
  justifyContent: "space-between",
}));
const UpperSection = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "10px",
  borderRadius: `${theme.shape.borderRadius} ${theme.shape.borderRadius} 0 0`,
  paddingRight: "20px",
  backgroundColor: theme.palette.primary.light,
  width: "100%",
}));

const PriceItemContainer = styled("div")(({ theme }) => ({
  width: "200px",
  display: "flex",
  justifyContent: "space-between",
}));
const PriceItemLeft = styled("div")(({ theme }) => ({
  width: "150px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
}));

const PriceItem = ({ title, price }: { title: string; price: number | boolean }) => {
  const theme = useTheme();

  return (
    <PriceItemContainer>
      <TotalPriceIcon />
      <PriceItemLeft>
        <Typography variant="body2" color={theme.palette.disabled.main}>
          {title}
        </Typography>
        {typeof price === "number" && <PriceComponent price={formatPrice(price)} />}
        {typeof price !== "number" && price ? (
          <Typography variant="body2" color={theme.palette.success.main}>
            بستانکار
          </Typography>
        ) : price === false ? (
          <Typography variant="body2" color={theme.palette.error.main}>
            بدهکار
          </Typography>
        ) : null}
      </PriceItemLeft>
    </PriceItemContainer>
  );
};

const DebotorsAndCreaditorsUpperComponent = () => {
  const reportReducer = useSelector((state: any) => state).reportReducer;
  const tabs = indexData("debtorsAndCreditors");
  const { dispatch, getState } = store
  const { setDates, fromDate, toDate } = useDateState(tabs && tabs[0]);
  const Token = getState().businessReducer.business?.token;

  const creditorsAndDebtors = reportReducer?.creditorsAndDebtors;
  const downloadExcel = () => {
    const data = {
      excel: true,
      "subColumn": "date",
      "searchText": fromDate,
      "searchTextAlt": toDate,

    };
    let url = `/reports/debtorsCreditors`;

    const tokenHeader = { Authorization: `Bearer ${Token}` };
    axios
      .post(url, data, {
        headers: { ...tokenHeader },
        responseType: "blob",
      })
      .then((response) => {
        const now = DateToString(Date.now()).replace("/", "_");
        fileDownload(response.data, `debtorsCreditors${now}.xlsx`);
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      }).finally(() => dispatch(appSetLoading(false)))
  }
  return (
    <div style={{ marginBottom: 24 }}>
      <div className="flex gap-4">
        <div className="w-[240px]">
          <BasicDateInput
            range
            placeholder="کل سال مالی"
            onChange={(x) => setDates(x)}
            defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
          />

        </div>
        <ExportContainer>
          <Item disableRipple onClick={downloadExcel}>
            <StyledListItemIcon>
              <SnippetFolderIcon color="success" />
            </StyledListItemIcon>
            <StyledListItemText sx={{ minWidth: '5rem' }}> دانلود اکسل </StyledListItemText>
          </Item>
        </ExportContainer>
      </div>
      {/* <MainContainer>
         <UpperSection>
  <TableSelectInvoice refetch={refetch} />
</UpperSection> 
        <LowerSectionContainer>
          <PriceItem title="بدهکاران" price={creditorsAndDebtors?.totalDebtor} />
          <PriceItem title="بستانکاران" price={creditorsAndDebtors?.totalCreditor} />
          <PriceItem
            title="مانده"
            price={Math.abs(creditorsAndDebtors?.totalCreditor - creditorsAndDebtors?.totalDebtor)}
          />
          <PriceItem
            title="ماهیت"
            price={creditorsAndDebtors?.totalCreditor - creditorsAndDebtors?.totalDebtor > 0 ? true : false}
          />
        </LowerSectionContainer>
      </MainContainer> */}
    </div>
  );
};

export default DebotorsAndCreaditorsUpperComponent;
